import React from "react";

import Sales from "../../Assets/Images/Vectors/sales.png";
import { FcAdvertising, FcConferenceCall, FcCustomerSupport,  FcSalesPerformance, FcSupport } from "react-icons/fc"


function About() {

    return (
        <section className="about" id="about">
            <div className="container flex mt-6">
                <h3 className="h2 section-title">
                    The Leading CRM Tailored for startups just like you.
                </h3>
                <p className="about-text">
                    With outstanding services and trusted business partners, we've customized
                    our platform with powerful features and features for your business.
                    Increase your revenue with enterprise-grade links built to acquire and engage customers.
                </p>
            </div>
            <div className="container">
                <div className="about-content mt-6 mb-5">
                    <strong className="subtittle">
                        Here's how DEEPBLUE can benefit your business.
                    </strong>
                    <p className="about-text">
                        Buid more meaningful and lasting relationships - better understand their needs, identify new opportunities to help, address any problems faster.
                    </p>

                    <ul className="about-list">
                        <li className="about-item">
                            <div className="about-item-icon">
                                < FcConferenceCall />
                            </div>

                            <p className="about-item-text">Boost your team's
                                efficiency and productivity by customizing any workflow to fit your team needs.</p>
                        </li>

                        <li className="about-item">
                            <div className="about-item-icon">
                                <FcSalesPerformance />
                            </div>

                            <p className="about-item-text">Automate your sales, marketing, and service in one platform.</p>
                        </li>

                        <li className="about-item">
                            <div className="about-item-icon">
                                <FcAdvertising />
                            </div>

                            <p className="about-item-text">Market like the most successful companies in the world with Agile CRMS's marketing automation software.</p>
                        </li>

                        <li className="about-item">
                            <div className="about-item-icon">

                                <FcCustomerSupport />
                            </div>

                            <p className="about-item-text">Great customer support separetes decent comapnies from excellent companines.</p>
                        </li>
                    </ul>

                </div>
                <figure className="about-banner">
                    <img src={Sales} alt="Sales" />
                </figure>
            </div>
        </section>
    );
}

export default About;